function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object, String, value) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-input-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr('label')) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-input-label-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("label", {
              "attrs": {
                for: $attr('field-id')
              },
              "class": {
                'mp-input-label': true
              },
            }, [__vjadeSafeCode($attr(`label`))]));
            __jade_nodes = __jade_nodes.concat(($attr('necessary')) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'mp-input-necessary': true
                },
              }, [__vjadeSafeCode($attr('necessary'))]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": {
            id: $attr('field-id'),
            name: $attr('field-name'),
            placeholder: $attr(`placeholder`),
            disabled: $attr(`disabled`),
            type: $attr(`type`),
            maxlength: $attr(`maxlength`),
          },
          "props": {
            value
          },
          "on": {
            input: $helpers.handleInput,
          },
          "hook": {
            insert: ({
              elm
            }) => $component.setElmRef(elm)
          },
          "class": Object.assign({}, {
            [`is-${$attr('validation-status')}`]: Boolean($attr('validation-status')),
          }, {
            'mp-input': true
          }),
        }));
        __jade_nodes = __jade_nodes.concat(($attr(`validation-status`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-input-right-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: {
                  valid: `circle-checkmark`,
                  invalid: `warning`
                }[$attr(`validation-status`)]
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(($attr('validation-status') === 'invalid' && $attr('error-message')) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-input-error-message': true
            },
          }, [__vjadeSafeCode($attr('error-message'))]));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "value" in locals ? locals.value : typeof value !== "undefined" ? value : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;